import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useMutation, useQuery } from "react-query";
import { Draggable, Droppable } from "react-beautiful-dnd";
import { useNavigate } from "react-router-dom";
//prime react
import { Dropdown } from "primereact/dropdown";
import { Skeleton } from "primereact/skeleton";
import { confirmDialog } from "primereact/confirmdialog";
import { Tooltip } from "primereact/tooltip";
//services
import { putTeams } from "../../services/Teams/putTeams";
import { getUserTeams } from "../../services/Teams/getUserTeams";
import { getTeam } from "../../services/GlobalRoles/getTeam";
//context
import { useAppContext } from "../../context/AppContext";
//images
import defaultImage from "../../assets/default.jpg";
import { deleteTeams } from "../../services/Teams/deleteTeams";
import { queryClient } from "../../utils/queryClient";
import { useParams } from "react-router-dom";
import { getContrastColor } from "../../utils/getContrastColor";
//components
import Modal from "../../components/modal/Modal";
import { InputNumber } from "primereact/inputnumber";
import { Button } from "primereact/button";

export function Members({
  teams,
  isRefetching,
  refetch,
  refetchMembers,
  loading,
  setLoading,
}) {
  const { id } = useParams();
  const { permissions } = useAppContext();
  const [showSelect, setShowSelect] = useState({});
  const [validateCorrImob, setValidateCorrImob] = useState(null);
  //controlar a modal
  const [visibleTeamId, setVisibleTeamId] = useState(null); // Armazena o ID do time com modal aberto
  //receber o objeto de comisspes
  const [commissions, setCommissions] = useState({}); // Objeto para armazenar as comissões por corretor
  const { data: userTeams } = useQuery("userTeams", () => getUserTeams());
  const { data: clients } = useQuery(
    ["users", userTeams],
    async () => {
      if (userTeams) {
        const allUsers = userTeams.map((dado) => ({
          value: dado.id.toString(),
          label: dado.name,
        }));
        return allUsers;
      }
    },
    {
      enabled: !!userTeams, // Enable this query only when fetchTeams is available
    }
  );
  const { mutateAsync: deleteTeamsFn } = useMutation({
    mutationFn: deleteTeams,
    onSuccess(_, variables) {
      queryClient.setQueryData([`teams${id}`], (data) => {
        const indexToRemove = data.findIndex((team) => team.id === variables);
        if (indexToRemove !== -1) {
          data.splice(indexToRemove, 1); // Remove o item
        }
        return [...data]; // Retorna o novo array
      });
      queryClient.setQueryData([`team${id}`], (data) => {
        const indexToRemove = data.findIndex((team) => team.id === variables);
        if (indexToRemove !== -1) {
          data.splice(indexToRemove, 1); // Remove o item
        }
        return [...data]; // Retorna o novo array
      });
    },
  });
  // Função para abrir o modal especifica de cada time passa o id como parametro
  const handleOpenComissions = (teamId, teamMembers) => {
    if (!commissions[teamId]) {
      setCommissions((prevState) => ({
        ...prevState,
        [teamId]: teamMembers.reduce((acc, member) => {
          if (
            member.registration_types.some(
              (type) => type.name !== "Imobiliária"
            )
          ) {
            acc[member.id] = member.percentage || ""; // Use o valor de comissão existente ou um valor padrão
          }
          return acc;
        }, {}),
      }));
    }
    setVisibleTeamId(teamId); // Define o ID do time para exibir o modal
    // getPercentageTeams(teamId); // Busca as comissões do time
  };

  // Atualizar comissão de um corretor específico de um time, manda o time, o corretor e o valor da comissao como parametro
  const handleCommissionChange = (teamId, memberId, value) => {
    //...prev pega o anterior para atualizar o novo
    // Atualiza o estado de commissions com o novo valor inserido, garantindo que cada corretor em cada time tenha uma comissão única e específica.
    setCommissions((prev) => ({
      ...prev,
      [teamId]: {
        ...prev[teamId],
        [memberId]: value,
      },
    }));
  };
  // Salvar todas as comissões de um time
  const handleSaveAllCommissions = async (teamId) => {
    // console.log("teamid", teamId)
    const notification = toast.loading("Por favor aguarde...");
    try {
        // Transformar os dados no formato necessário
        const membersData = teams[0].members
            .filter((member) =>
                member.registration_types?.some((type) => type.name !== "ninguem")
            )
            .map((member) => ({
                id: member.id,
                percentage: commissions[teamId]?.[member.id] || 0,
            }));
            console.log("membersData", membersData)

        const sendData = {
            team_id: teamId,
            members: membersData,
        };

        // Fazer o PUT para o endpoint
        const response = await putTeams(sendData);

        if (response.success) {
            toast.update(notification, {
                render: response.success,
                autoClose: 5000,
                type: "success",
                isLoading: false,
            });
            closeModal();
        } else {
            toast.update(notification, {
                render: "Oops, algo deu errado. Tente novamente!",
                autoClose: 5000,
                type: "error",
                isLoading: false,
            });
        }
    } catch (error) {
        let errorMessage = "Erro ao atualizar a comissão. Tente novamente mais tarde.";
        // Verifica se o erro tem uma resposta do backend
        if (error.response) {
          console.log("error", error);
          errorMessage = error.response.data?.errors?.members?.[0] || errorMessage;
      } else if (error.message) {
          errorMessage = error.message;
      }
      

        toast.update(notification, {
            render: errorMessage,
            autoClose: 5000,
            type: "error",
            isLoading: false,
        });
    }
};

  // Função para fechar o modal
  const closeModal = () => {
    setVisibleTeamId(false);
  };

  const handleToggleSelect = (teamId) => {
    setShowSelect((prevState) => ({
      ...prevState,
      [teamId]: !prevState[teamId], // Inverte o estado de exibição para o time clicado
    }));
  };

  const handleSetUser = async (e, id) => {
    refetch();
    setLoading(true);
    const notification = toast.loading("Por favor aguarde...");

    const memberId = parseInt(e);
    const teamId = parseInt(id);

    // Obtendo os membros existentes do time pelo ID do time
    const teamIndex = teams.findIndex((team) => team.id === teamId);
    const existingMembers = teams[teamIndex].members.map((member) => member.id);
    // Adicionando o novo membro à lista de membros existentes
    // const updatedMembers = [...existingMembers, memberId];
    //    console.log("Updated Members: ", updatedMembers);
    // const data = {
    //   team_id: teamId,
    //   members: updatedMembers,
    // };
    console.log("Teams: ", teams);
    console.log("Team Index: ", teamIndex);
    const membersData = teams[teamIndex].members
      .filter((member) =>
        member.registration_types?.some((type) => type.name !== "ninguem")
      )
      .map((member) => ({
        id: member.id,
        percentage: member.percentage ?? 0,
      }));
    const updatedMembers = [...membersData, { id: memberId, percentage: 0 }];

    const sendData = {
      team_id: teamId,
      members: updatedMembers,
    };
    // console.log("sendData", sendData);
    // return;

    try {
      await putTeams(sendData);

      refetchMembers().then(() => {
        setShowSelect({});
        toast.update(notification, {
          render: "Membro adicionado ao time!",
          autoClose: 1000,
          type: "success",
          isLoading: false,
        });
        setLoading(false);
      });
    } catch (error) {
      refetchMembers().then(() => {
        setShowSelect({});
        toast.update(notification, {
          render: "Não foi possível adicionar o usuário no time!",
          autoClose: 1000,
          theme: "colored",
          type: "warning",
          isLoading: false,
        });
        setLoading(false);
      });
    }
  };

  async function deleteMember(team, memberId) {
    // console.log("team", team);
    // console.log("member", memberId);
    setLoading(true);
    const notification = toast.loading("Por favor aguarde...");

    const filterTeam = teams.find(({ id }) => id === team);

    // console.log("filter", filterTeam);

    const filterMembers = filterTeam.members
      .filter((member) => member.id !== memberId)
      .map((member) => ({ id: member.id, percentage: member.percentage }));

    const data = {
      team_id: filterTeam.id,
      members: filterMembers,
    };

    try {
      await putTeams(data);

      refetchMembers().then(() => {
        toast.update(notification, {
          render: "Usuário Removido!",
          autoClose: 1000,
          theme: "colored",
          type: "success",
          isLoading: false,
        });
        setLoading(false);
      });
      //    console.log(response);
    } catch (error) {
      refetchMembers().then(() => {
        toast.update(notification, {
          render: "Não foi possível remover o usuário do time!",
          autoClose: 1000,
          theme: "colored",
          type: "warning",
          isLoading: false,
        });
        setLoading(false);
      });
    }
    // refetch();
  }

  async function deleteTeam(teamId) {
    setLoading(true);
    const notification = toast.loading("Por favor aguarde...");

    try {
      await deleteTeamsFn(teamId);
      toast.update(notification, {
        render: "Time Removido!",
        autoClose: 1000,
        theme: "colored",
        type: "success",
        isLoading: false,
      });
      setLoading(false);
      //    console.log(response);
    } catch (error) {
      toast.update(notification, {
        render: "Não foi possível remover o time!",
        autoClose: 1000,
        theme: "colored",
        type: "warning",
        isLoading: false,
      });
      setLoading(false);
    }
    // refetch();
  }

  const handleDeleteTeam = (teamId) => {
    confirmDialog({
      message: "Deseja remover o time?",
      header: "Confirmação",
      icon: "pi pi-info-circle",
      defaultFocus: "reject",
      acceptClassName: "p-button",
      acceptLabel: "Sim",
      rejectLabel: "Não",
      accept: () => deleteTeam(teamId),
    });
  };

  const handleDeleteMember = (team, member) => {
    confirmDialog({
      message: "Deseja remover o membro?",
      header: "Confirmação",
      icon: "pi pi-info-circle",
      defaultFocus: "reject",
      acceptClassName: "p-button",
      acceptLabel: "Sim",
      rejectLabel: "Não",
      accept: () => deleteMember(team, member),
    });
  };

  useEffect(() => {
    if (teams) {
      const validate = teams.map((team, index) => {
        const hasCorretor = team.members.some((person) =>
          person.registration_types.some((type) => type.name === "Corretor")
        );

        const hasImob = team.members.some((person) =>
          person.registration_types.some((type) => type.name === "Imobiliária")
        );

        return {
          id: team.id,
          hasCorretor: hasCorretor,
          hasImob: hasImob,
        };
      });

      setValidateCorrImob(validate);
    }
  }, [teams, isRefetching]);

  return !teams ? (
    <h2>Carregando...</h2>
  ) : (
    teams &&
      teams?.map((team, teamIndex) => (
        <Droppable
          key={team.id.toString()}
          className="row"
          droppableId={team.id.toString()} // Use o ID do time como droppableId
          index={teamIndex}
        >
          {(provided) => (
            <div
              className="col-md-4"
              {...provided.droppableProps}
              ref={provided.innerRef}
            >
              <div className="holder">
                {showSelect[team.id] && permissions.includes("103") ? ( // Editar Time / Configurar Membros
                  <div>
                    <div
                      style={{ backgroundColor: `${team.color} !important` }}
                    >
                      {/* Seletor de usuário */}
                      <Dropdown
                        onChange={(e) => {
                          handleSetUser(e.target.value, team.id);
                        }}
                        style={{
                          height: 40,
                          background: "#2D353C",
                          border: "none",
                        }}
                        showClear
                        options={clients}
                        disabled={loading}
                        optionLabel="label"
                        placeholder="Clique para adicionar um Usuário"
                        filter
                        emptyFilterMessage="Nenhum Usuário encontrado."
                        className="w-100 text-white"
                      />
                    </div>
                  </div>
                ) : (
                  <div
                    className="holder__title d-flex"
                    style={{ "--background-color": team.color }}
                  >
                    <div style={{ color: getContrastColor(team.color) }}>
                      {team.name}
                    </div>
                    <div className="d-flex align-items-center justify-content-start gap-3">
                      {validateCorrImob?.find(
                        (item) =>
                          item.id === team.id &&
                          (!item.hasCorretor || !item.hasImob)
                      ) && (
                        <>
                          <Tooltip target=".fa-triangle-exclamation" />
                          <i
                            className="fa fa-triangle-exclamation card-animation me-2"
                            data-pr-tooltip="Para realizar uma venda adicione um Corretor e uma Imobiliária ao time."
                            data-pr-position="top"
                            style={{ fontSize: "18px" }}
                          ></i>
                        </>
                      )}
                      {/* definir a comissao */}
                      <span
                        className="h-100 my-auto"
                        onClick={() =>
                          handleOpenComissions(team.id, team.members)
                        }
                        style={{ color: getContrastColor(team.color) }}
                      >
                        <i className="fa-solid fa-gear rounded-circle text-white p-2 "></i>
                      </span>
                      {permissions &&
                        permissions.includes("103") && ( // Editar Time / Configurar Membros
                          <div
                            onClick={() => handleToggleSelect(team.id)}
                            className="me-2"
                            style={{ color: getContrastColor(team.color) }}
                          >
                            <i
                              className="fa fa-plus card-animation"
                              style={{ fontSize: "18px" }}
                            ></i>
                          </div>
                        )}
                      {permissions &&
                        permissions.includes("104") && ( // Deletar Time / Configurar Membros
                          <div
                            onClick={() => handleDeleteTeam(team.id)}
                            className="ms-2"
                            style={{ color: getContrastColor(team.color) }}
                          >
                            <i
                              className="fa fa-trash-can card-animation"
                              style={{ fontSize: "16px" }}
                            ></i>
                          </div>
                        )}
                    </div>
                  </div>
                )}
                {/* modal que declara o valor das comissoes */}
                <Modal
                  visible={visibleTeamId === team.id} // Apenas o modal do time específico será exibido
                  dynamicTitle={
                    "Defina a Porcentagem de Comissão para os membros do time"
                  }
                  onHide={closeModal}
                  closable={true}
                >
                  <div className="row justify-content-start p-2">
                    <p>
                      Cadastre comissão para os membros do time{" "}
                      <strong>{team.name}</strong>
                    </p>

                    {/* Filtrar membros que são corretores */}
                    {team.members.filter((member) =>
                      member.registration_types.some(
                        (type) => type.name != "Imobiliária"
                      )
                    ).length === 0 ? (
                      <div className="col-12">
                        <p className="text-danger">
                          Não há membros no time. Adicione membros para definir
                          as comissões.
                        </p>
                      </div>
                    ) : (
                      team.members
                        .filter((member) =>
                          member.registration_types.some(
                            (type) => type.name != "Imobiliária"
                          )
                        )
                        .map((member) => (
                          <div
                            key={member.id}
                            className="col-12 mb-3"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "10px",
                            }}
                          >
                            <label
                              htmlFor={`commission-${team.id}-${member.id}`}
                              className="form-label"
                            >
                              Porcentagem de Comissão para {member.name} (%)
                            </label>
                            <InputNumber
                              id={`commission-${team.id}-${member.id}`}
                              value={commissions[team.id]?.[member.id] || ""}
                              onValueChange={(e) =>
                                handleCommissionChange(
                                  team.id,
                                  member.id,
                                  e.value
                                )
                              }
                              name="comissions_value"
                              mode="decimal"
                              min={0}
                              step={1}
                              max={100}
                              placeholder="Ex.: 10%"
                              useGrouping={false}
                              suffix="%"
                            />
                          </div>
                        ))
                    )}
                    {team.members.some((member) =>
                      member.registration_types.some(
                        (type) => type.name === "Corretor"
                      )
                    ) && (
                      <div className="col-12">
                        <Button
                          className="btn btn-primary"
                          onClick={() => handleSaveAllCommissions(team.id)}
                          disabled={
                            !commissions[team.id] || // Verifica se há dados no estado de comissões
                            team.members
                              .filter((member) =>
                                member.registration_types.some(
                                  (type) => type.name === "Corretor"
                                )
                              )
                              .some(
                                (member) =>
                                  commissions[team.id][member.id] ===
                                    undefined || // Verifica se falta algum valor
                                  commissions[team.id][member.id] === "" // Verifica se algum campo está vazio
                              )
                          }
                        >
                          Salvar Comissões
                        </Button>
                      </div>
                    )}
                  </div>
                </Modal>

                {/* Renderizar os membros do time */}
                {!team && <Skeleton width="100%" height="80vh" />}
                <div className="holder__content">
                  <ul className="list">
                    {/* {console.log("T Members: ", team?.members)} */}
                    {team?.members.map((member, memberIndex) => (
                      <Draggable
                        key={`${team.id}-${member.id}`} // Combinação de IDs de time e membro
                        draggableId={`${team.id}-${member.id}`} // Combinação de IDs de time e membro
                        index={memberIndex}
                        isDragDisabled={!permissions.includes("103")} // Editar Time / Membros
                      >
                        {(provided) => (
                          <li
                            className={`list__item selected`}
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                          >
                            <div
                              className="card-time d-flex flex-wrap justify-content-between 
                              flex-column flex-md-row align-items-start align-items-md-center 
                              "
                            >
                              <div>
                                <img
                                  className="rounded-circle me-2"
                                  src={
                                    member.profile_photo
                                      ? member.profile_photo?.path
                                      : defaultImage
                                  }
                                  width={50}
                                  height={50}
                                  alt="user"
                                />
                                {member.name}
                              </div>
                              <div className="d-flex gap-2 mt-2 mt-md-0  w-md-auto">
                                {permissions?.includes("104") && ( // Deletar Time
                                  <>
                                    {loading ? (
                                      <span
                                        className="h-100 my-auto"
                                        onClick={() =>
                                          handleOpenComissions(
                                            team.id,
                                            member.id
                                          )
                                        }
                                      >
                                        <i className="fa-solid fa-trash-can rounded-circle text-white p-2 bg-muted"></i>
                                      </span>
                                    ) : (
                                      <span
                                        onClick={() =>
                                          handleDeleteMember(team.id, member.id)
                                        }
                                        className="h-100 my-auto"
                                      >
                                        <i className="fa-solid fa-trash-can rounded-circle text-white p-2 bg-red"></i>
                                      </span>
                                    )}
                                  </>
                                )}
                              </div>
                            </div>
                          </li>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </ul>
                </div>
              </div>
            </div>
          )}
        </Droppable>
      ))
  );
}
